import { Endpoints } from 'modules/common/components/GetStartedSection/components/Endpoints';
import { isMultichain } from 'modules/chains/utils/isMultichain';
import { useChainSelectors } from 'modules/chains/components/ChainSelectorsProvider';
import { useEndpointsGroup } from 'modules/chains/hooks/useEndpointsGroup';
import { useEndpointsPlaceholder } from 'modules/chains/hooks/useEndpointsPlaceholder';

interface EndpointsContainerProps {
  userEndpointToken?: string;
}

export const EndpointsContainer = ({
  userEndpointToken,
}: EndpointsContainerProps) => {
  const { chain, chainType } = useChainSelectors();

  const endpointsGroup = useEndpointsGroup();

  const placeholder = useEndpointsPlaceholder(isMultichain(chain.id));

  return (
    <Endpoints
      chainType={chainType}
      group={endpointsGroup}
      placeholder={placeholder}
      publicChain={chain}
      userEndpointToken={userEndpointToken}
    />
  );
};
